// extracted by mini-css-extract-plugin
module.exports = {"description":"QuotazioneGaranziaRcaBox_description__oCFjq","list":"QuotazioneGaranziaRcaBox_list__NF36t"};